/**
 * @name Stage.js
 */
import * as THREE from "three";

class Stage {
    constructor(world, params) {
        this.world = world;
        this.params = params;
        this.renderer = null;

        this.__init();
    }

    /**
     * @name __init
     */
    __init() {
        this.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true, });
        this.renderer.autoClear = false;
        this.renderer.setSize(this.params.size.w, this.params.size.h);
        this.renderer.setClearColor(this.params.color.black, this.params.alpha);
        this.renderer.setPixelRatio(Math.min(2, window.devicePixelRatio));
        this.world.appendChild(this.renderer.domElement);

        // PC以外の場合、アドレスバーの分だけ高さを調整
        if (UA.data.device != "pc") {
            this.renderer.domElement.style.top = this.params.size.pos;
        }
    }

    /**
     * @name __resize
     */
    __resize(params) {
        this.params = params;
        this.renderer.setSize(this.params.size.w, this.params.size.h);
        this.renderer.setPixelRatio(Math.min(2, window.devicePixelRatio));
    }
}

export default Stage;